import { gql, useMutation } from '@apollo/client'
import {
  MutationVehicleStatusRefreshArgs,
  MutationVehicleStatusRefreshPayload,
} from 'src/generated'

const MUTATION_VEHICLE_STATUS_REFRESH = gql`
  mutation VehicleStatusRefresh($input: MutationVehicleStatusRefreshInput!) {
    vehicleStatusRefresh(input: $input) {
      vehicleStatusId
    }
  }
`

const useVehicleStatusRefreshMutation = () => {
  return useMutation<
    { vehicleStatusRefresh: MutationVehicleStatusRefreshPayload },
    MutationVehicleStatusRefreshArgs
  >(MUTATION_VEHICLE_STATUS_REFRESH)
}

export default useVehicleStatusRefreshMutation
